export default class FilterBuilder {
  filter = {};
  and = expr => {
    this.filter = {
      ...this.filter,
      ...expr
    };
    return this;
  };
  condition = (condition, expr) => condition ? this.and(expr) : this;
  dateRange = (prop, startDate, endDate) => {
    if (!startDate && !endDate) return this;
    let expr = {};
    if (startDate) expr = {
      ...expr,
      ge: startDate
    };
    if (endDate) expr = {
      ...expr,
      le: endDate
    };
    return this.and({
      [prop]: expr
    });
  };
  value = () => this.filter;
}